export enum CategoryTypeEnum {
  REPAIR = 'REPAIR',
  BUSINESS = 'BUSINESS',
  BUY_BACK = 'BUY_BACK',
  CUSTOMIZATION = 'CUSTOMIZATION',
  PERFORMANCE = 'PERFORMANCE',
  PERSONAL_SHOPPER = 'PERSONAL_SHOPPER',
  RENTAL = 'RENTAL',
  SPORT_ACTIVITY = 'SPORT_ACTIVITY',
  TEST_AND_BUY = 'TEST_AND_BUY',
  TEST_E_BIKE = 'TEST_E_BIKE',
  UNAVAILABILITY = 'UNAVAILABILITY',
  VISIO_STORE = 'VISIO_STORE',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  TEST_ROAD_GRAVEL_BIKE = 'TEST_ROAD_GRAVEL_BIKE',
  UNKNOWN = 'UNKNOWN',
}
